export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });
}

export function acronym(str: string) {
  return str
    .split(/\s+/)
    .map((word) => word[0].toUpperCase())
    .join("")
    .slice(0, 3);
}

export function toKebabCase(str: string) {
  return str
    .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, "")
    .replace(/([a-z])([A-Z])/g, (_m, a, b) => `${a}_${b.toLowerCase()}`)
    .replace(/[^A-Za-z0-9]+|_+/g, "-")
    .toLowerCase();
}

export function toDomain(str: string) {
  try {
    const url = new URL(str);
    return url.hostname.replace(/^www\./, "");
  } catch {
    // Fallback for invalid URLs (e.g. missing protocol)
    const match = str.match(/^(?:https?:\/\/)?(?:www\.)?([^/]+)/i);
    return match ? match[1] : "";
  }
}
